/**
 * 작업 날짜 모달 (BS)
 */
export default class WorkDay {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.instMobi = null;
    }

    getHtml = function(){
        return `<div id="window-workday" class="arrive_day"><input class="calendar" type="hidden"/></div>`;
    }

    init = function() {
        this.parent.setTitle('작업날짜');
        $('#' + this.id).html(this.getHtml());

        this.draw();
        this.initHandler();
    }

    destroy() {
        $('#window-workday .calendar').mobiscroll('destroy');
        $('#window-workday').off();
    }

    draw(){
        const self = this;

        // 달력그리기
        let date = null;
        if( this.data['work_time'] ) {
            if( ['otherorder','copyorder'].includes(self.data.$p.editMode) ){// otherorder (추가발주), copyorder (오더복사), myorderedit (수정)
                date = dayjs().toDate();
            }else {
                date = dayjs(this.data['work_time']).toDate();
            }
        }

        $(`#window-workday .calendar`).mobiscroll('destroy');
        this.instMobi = $(`#window-workday .calendar`).mobiscroll().datepicker({
            controls: ['calendar'],
            display: 'inline',
            locale: mobiscroll.localeKo,
            defaultSelection: date,
            buttons: [],  // 설정 버튼 제거
            onCellClick: function (args, inst) {
                if (args.date) {
                    if (args.outer) {
                        inst.navigate(args.date); // 월 이동 강제 처리
                        setTimeout(() => {
                            inst.setVal(args.date, true); // 날짜 선택 강제 적용
                            self.updateWorkDay(args.date); // 작업일 업데이트
                        }, 1);
                    } else {
                        inst.setVal(args.date, true); // 선택 강제 적용
                        self.updateWorkDay(args.date); // 작업일 업데이트
                    }
                }
            },
        }).mobiscroll('getInst');
        // 머리의 '오늘' — 칸 클릭과 같게 작업일을 반영한다 (내장 버튼은 onCellClick 을 안 태운다)
        $j.Common.Mobiscroll.onToday($('#window-workday'), (d) => self.updateWorkDay(d));
    };

    initHandler(){
    }

    updateWorkDay = function (date) {
        const work_day = dayjs(date).format('YYYY-MM-DD');
        const work_time = work_day + ' ' + dayjs(this.data['work_time']).format('HH:mm:00');
        this.data['work_day'] = work_day;
        this.data['work_time'] = work_time;
        this.apply();
    };

    apply = function () {
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
}
